import { useEffect, type ReactNode } from 'react'
import { useRouter } from 'next/router'

import { Spinner } from '@wartek-id/spinner'
import { useToast } from '@wartek-id/toast'

import usePeriodContext from 'app/KinerjaShared/hooks/usePeriodContext'
import { isDateStarted } from 'app/KinerjaShared/utils/pelaksanaan'
import { PENGELOLAAN_KINERJA_GPK_PEGAWAI_PATH } from 'app/KinerjaShared/constants/path'

type PageGuardGpkPelaksanaanDateProps = {
  children?: ReactNode
}

export function PageGuardGpkPelaksanaanDate({
  children,
}: PageGuardGpkPelaksanaanDateProps) {
  const toast = useToast()
  const router = useRouter()

  const { period, periods } = usePeriodContext()

  const isPelaksanaanDateStarted = isDateStarted(period.periodeKinerja)
  const isResolved = Array.isArray(periods) && periods.length > 0

  useEffect(() => {
    // If the pelaksanaan date for the current period hasn't started yet, redirect to the GPK pegawai homepage
    if (isResolved && !isPelaksanaanDateStarted) {
      router.replace(PENGELOLAAN_KINERJA_GPK_PEGAWAI_PATH)
      toast({
        message:
          'Tahap Pelaksanaan dan Penilaian belum dimulai untuk periode tersebut.',
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isResolved, isPelaksanaanDateStarted])

  if (!isResolved || !isPelaksanaanDateStarted) {
    return (
      <div className="flex py-20 justify-center">
        <Spinner />
      </div>
    )
  }

  return <>{children}</>
}
